define(function(require) {
    const Cell = require('../BaseCell');
    const _ = require('underscore');
    const CC = require('CC');
    const CurrencyMap = require('data/currencies.json');

    /**
     * Currency Cell
     * @param {Object} options
     * @returns column definition
     */
    const CurrencyCell = function(options) {
        return {
            CellClass: Cell,
            options: _.extend(
                {
                    className: 'dt-body-right text-right',
                    currencyCode: model => {
                        return 'usd';
                    },
                    onDisplay: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        const model = this.findModel(rowModel, row);
                        const currencyCode = this.currencyCode(model);
                        const currency = parseFloat(translatedValue);
                        if (currency && !isNaN(currency)) {
                            const currencyInfo = CurrencyMap[currencyCode];
                            if (currencyInfo) {
                                const decimalPlaces = currencyInfo.decimal_digits;
                                return `${currencyInfo.symbol_native}${CC.converters.formatCurrency(
                                    currency,
                                    decimalPlaces
                                )}`;
                            }
                            return `$${CC.converters.formatCurrency(currency, 2)}`;
                        } else if (currency === 0) {
                            return '$0.00';
                        }
                        return options.defaultContent;
                    },
                    onExport: function(data, type, row, meta, translatedValue, rowModel = undefined) {
                        // Identical formatting
                        return this.onDisplay(data, type, row, meta, translatedValue, rowModel);
                    }
                },
                options
            )
        };
    };
    return CurrencyCell;
});
